import React from 'react';
import { Folder as FolderIcon, InsertDriveFile as FileIcon } from '@material-ui/icons';
import AlterImage from 'Assets/no-image-available.png';
import styles from '../index.legacy.module.css';

const ContributorFolderCard = ({ contributor, onClick }) => {
  const displayName = contributor.contributor_name || 'Unknown';
  const displayEmail = contributor.contributor_email || '';
  const videoCount = contributor.video_count || 0;
  const albumCount = contributor.album_count || 0;
  const recentContributions = contributor.recent_contributions || [];

  // Build count display string (show only non-zero counts)
  const countParts = [];
  if (videoCount > 0) {
    countParts.push(`${videoCount} video${Number(videoCount) === 1 ? '' : 's'}`);
  }
  if (albumCount > 0) {
    countParts.push(`${albumCount} album${Number(albumCount) === 1 ? '' : 's'}`);
  }
  const countDisplay = countParts.join(', ') || 'No content';

  // Total for overflow calculation
  const contributionCount = videoCount + albumCount;

  // Get up to 4 thumbnails from recent contributions
  const thumbnails = recentContributions.slice(0, 4).map((contrib) => {
    // For videos, thumbnail is in payload.payload.thumbnail_signed
    // For albums, icon is in payload.payload.icon_signed
    const payload = contrib.payload?.payload;
    return payload?.thumbnail_signed || payload?.icon_signed || null;
  });

  // Always fill to 4 cells for consistent grid
  const gridCells = Array.from({ length: 4 }, (_, index) => thumbnails[index] || null);

  // Calculate overflow count (if more than 4 contributions)
  const overflowCount = contributionCount > 4 ? contributionCount - 4 : 0;

  return (
    <div
      className={styles.contributorFolderCard}
      onClick={() => onClick(contributor)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          onClick(contributor);
        }
      }}
    >
      {/* Thumbnail Grid */}
      <div className={styles.folderThumbnailGrid}>
        {/* Folder Icon Overlay */}
        <div className={styles.folderIconOverlay}>
          <FolderIcon />
        </div>

        {thumbnails.length > 0 ? (
          gridCells.map((thumb, index) => (
            <div key={index} className={styles.folderThumbnailCell}>
              {thumb ? (
                <img
                  src={thumb}
                  alt={`Contribution ${index + 1}`}
                  className={styles.folderThumbnailImage}
                  onError={(e) => {
                    e.target.src = AlterImage;
                  }}
                />
              ) : (
                <div className={styles.folderThumbnailPlaceholder}>
                  <FileIcon />
                </div>
              )}
              {/* Show overflow count on the 4th thumbnail */}
              {index === 3 && overflowCount > 0 && (
                <div className={styles.folderOverflowOverlay}>
                  <span>{`+${overflowCount}`}</span>
                </div>
              )}
            </div>
          ))
        ) : (
          // Empty folder placeholder - show 4 empty cells
          <>
            {Array.from({ length: 4 }).map((_, index) => (
              <div key={index} className={styles.folderThumbnailCell}>
                <div className={styles.folderThumbnailPlaceholder}>
                  <FileIcon />
                </div>
              </div>
            ))}
          </>
        )}
      </div>

      {/* Folder Info */}
      <div className={styles.folderInfo}>
        <div className={styles.folderName}>{displayName}</div>
        {displayEmail && (
          <div className={styles.folderEmail}>{displayEmail}</div>
        )}
        <div className={styles.folderCount}>
          {countDisplay}
        </div>
      </div>
    </div>
  );
};

export default ContributorFolderCard;
